/**
 * Slate Coaster Landing Page — v3
 * Multi-add flow with holder, gift wrap, upload, variety pack, and volume pricing
 * 3Blades Maker Lab
 */
(function () {
  'use strict';

  var config = JSON.parse(document.getElementById('slate-landing-data').textContent);
  var pickProduct = null;
  var customProduct = null;
  var holderProduct = null;
  var giftWrapProduct = null;
  var volumeProducts = {}; // keyed by handle
  var orderSets = [];
  var uploadedFileData = null;
  var uploadedFileName = null;
  var selectedDesignName = null;
  var varietySlots = []; // array of { name, imgSrc } or null per slot

  var state = {
    shape: 'Square (4")',
    color: 'Black',
    packSize: '4-Pack',
    designType: 'pick',
    holder: 'no',
    holderColor: 'Black',
    giftWrap: 'no',
    qty: 1
  };

  // DOM
  var $ = function (id) { return document.getElementById(id); };
  var els = {
    pickSection: $('slatePickSection'),
    customSection: $('slateCustomSection'),
    varietySection: $('slateVarietySection'),
    designGrid: $('slateDesignGrid'),
    varietyGrid: $('slateVarietyGrid'),
    slotBar: $('slateSlotBar'),
    slotStatus: $('slateSlotStatus'),
    designerBtn: $('slateDesignerBtn'),
    fileUpload: $('slateFileUpload'),
    uploadStatus: $('slateUploadStatus'),
    holderColorGroup: $('slateHolderColorGroup'),
    qty: $('slateQty'),
    lineTotal: $('slateLineTotal'),
    addSet: $('slateAddSet'),
    orderList: $('slateOrderList'),
    orderItems: $('slateOrderItems'),
    subtotal: $('slateSubtotal'),
    finish: $('slateFinish'),
    finishHint: $('slateFinishHint'),
    previewImg: $('slatePreviewImg'),
    previewPlaceholder: $('slatePreviewPlaceholder'),
    volumeToggle: $('slateVolumeToggle'),
    volumeBody: $('slateVolumeBody')
  };

  // ——— Helpers ———

  function getSlotCount() {
    return state.packSize === '6-Pack' ? 6 : 4;
  }

  // ——— Product Fetching ———

  function fetchProducts() {
    var baseHandles = [
      config.pickDesignHandle,
      config.customDesignHandle,
      config.holderHandle,
      config.giftWrapHandle
    ];

    // Also fetch volume products
    var volHandles = config.volumeHandles || {};
    var volKeys = Object.keys(volHandles);
    var allHandles = baseHandles.concat(volKeys.map(function (k) { return volHandles[k]; }));

    var fetches = allHandles.map(function (h) {
      return fetch('/products/' + h + '.json').then(function (r) { return r.json(); });
    });

    Promise.all(fetches).then(function (results) {
      pickProduct = results[0].product;
      customProduct = results[1].product;
      holderProduct = results[2].product;
      giftWrapProduct = results[3].product;

      // Store volume products by handle
      for (var i = 4; i < results.length; i++) {
        if (results[i].product) {
          volumeProducts[allHandles[i]] = results[i].product;
        }
      }

      buildDesignGrid();
      buildEdgeGallery();
      updateLineTotal();
      updatePreview();
      autoSelectDesignFromUrl();
    });
  }

  // ——— Variant Matching ———

  function findCoasterVariant(product, packSize, shape, color) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.option1 === packSize && v.option2 === shape && v.option3 === color) return v;
    }
    return null;
  }

  function findHolderVariant(color) {
    if (!holderProduct) return null;
    for (var i = 0; i < holderProduct.variants.length; i++) {
      if (holderProduct.variants[i].title === color) return holderProduct.variants[i];
    }
    return holderProduct.variants[0];
  }

  function getVariantPrice(variant) {
    if (!variant) return 0;
    var p = parseFloat(variant.price);
    return p > 500 ? p / 100 : p;
  }

  // ——— Volume Product Selection ———

  function getVolumeCoasterProduct(qty) {
    var volHandles = config.volumeHandles || {};
    var typeKey = (state.designType === 'pick' || state.designType === 'variety') ? 'pick' : 'custom';
    var handle = null;
    if (qty >= 25) handle = volHandles[typeKey + '25'];
    else if (qty >= 10) handle = volHandles[typeKey + '10'];
    if (handle && volumeProducts[handle]) return volumeProducts[handle];
    return null;
  }

  function getVolumeHolderProduct(qty) {
    var volHandles = config.volumeHandles || {};
    var handle = null;
    if (qty >= 25) handle = volHandles.holder25;
    else if (qty >= 10) handle = volHandles.holder10;
    if (handle && volumeProducts[handle]) return volumeProducts[handle];
    return null;
  }

  function getVolumeGiftWrapProduct(qty) {
    var volHandles = config.volumeHandles || {};
    var handle = null;
    if (qty >= 25) handle = volHandles.giftWrap25;
    else if (qty >= 10) handle = volHandles.giftWrap10;
    if (handle && volumeProducts[handle]) return volumeProducts[handle];
    return null;
  }

  // ——— Price Calculation ———

  function getTierPrice(tierObj, qty) {
    if (qty >= 25 && tierObj.tier25 != null) return tierObj.tier25;
    if (qty >= 10 && tierObj.tier10 != null) return tierObj.tier10;
    return tierObj.base;
  }

  function getCoasterTierPrice(qty) {
    var coasterTiers = config.volumePricing.coasters;
    if (!coasterTiers) return null; // fallback to variant price
    var typeKey = (state.designType === 'pick' || state.designType === 'variety') ? 'pick' : 'custom';
    var packTiers = coasterTiers[typeKey] && coasterTiers[typeKey][state.packSize];
    if (!packTiers) return null;
    return getTierPrice(packTiers, qty);
  }

  function calcSetPrice() {
    var qty = state.qty;
    var coasterPrice = getCoasterTierPrice(qty);
    if (coasterPrice == null) {
      var product = (state.designType === 'pick' || state.designType === 'variety') ? pickProduct : customProduct;
      var coasterVariant = findCoasterVariant(product, state.packSize, state.shape, state.color);
      coasterPrice = getVariantPrice(coasterVariant);
    }
    var holderPrice = state.holder === 'yes' ? getTierPrice(config.volumePricing.holder, qty) : 0;
    var wrapPrice = state.giftWrap === 'yes' ? getTierPrice(config.volumePricing.giftWrap, qty) : 0;
    return (coasterPrice + holderPrice + wrapPrice) * qty;
  }

  function updateLineTotal() {
    var total = calcSetPrice();
    els.lineTotal.textContent = '$' + total.toFixed(2);

    // Show per-set price when volume discount applies
    var qty = state.qty;
    var tierPrice = getCoasterTierPrice(qty);
    if (qty >= 10 && tierPrice != null) {
      var perSet = total / qty;
      els.lineTotal.textContent = '$' + total.toFixed(2) + ' ($' + perSet.toFixed(2) + '/set)';
    }

    updateAddSetState();
  }

  function updateAddSetState() {
    if (state.designType === 'pick' && !selectedDesignName) {
      els.addSet.disabled = true;
      els.addSet.textContent = 'Select a Design First';
    } else if (state.designType === 'variety') {
      var filled = 0;
      for (var i = 0; i < varietySlots.length; i++) { if (varietySlots[i]) filled++; }
      var total = getSlotCount();
      if (filled < total) {
        els.addSet.disabled = true;
        els.addSet.textContent = 'Fill All Slots (' + filled + ' of ' + total + ')';
      } else {
        els.addSet.disabled = false;
        els.addSet.textContent = 'Add Set';
      }
    } else if (state.designType === 'custom' && !uploadedFileData) {
      els.addSet.disabled = true;
      els.addSet.textContent = 'Upload a Design or Use Designer';
    } else {
      els.addSet.disabled = false;
      els.addSet.textContent = 'Add Set';
    }
  }

  // ——— Preview Image ———

  var currentPreviewSrc = null;
  var currentEdgeSrc = null;
  var previewHoverBound = false;

  function findEdgeImage(designName) {
    if (!pickProduct) return null;
    var images = pickProduct.images || [];
    var designSlug = designName.toLowerCase().replace(/&/g, 'and').replace(/\s+/g, '-');
    for (var i = 0; i < images.length; i++) {
      var alt = (images[i].alt || '').toLowerCase();
      if (alt.indexOf(designSlug) > -1 && alt.indexOf('edge') > -1) {
        return images[i].src;
      }
    }
    return null;
  }

  function setupPreviewHover() {
    if (previewHoverBound) return;
    previewHoverBound = true;
    var box = document.getElementById('slatePreviewBox');
    if (!box) return;

    // Desktop: hover
    box.addEventListener('mouseenter', function () {
      if (currentEdgeSrc) {
        els.previewImg.src = currentEdgeSrc.replace(/\.([a-z]+)\?/, '_600x600.$1?');
      }
    });
    box.addEventListener('mouseleave', function () {
      if (currentPreviewSrc) {
        els.previewImg.src = currentPreviewSrc.replace(/\.([a-z]+)\?/, '_600x600.$1?');
      }
    });

    // Mobile: tap to toggle
    var showingEdge = false;
    box.addEventListener('touchstart', function (e) {
      if (!currentEdgeSrc) return;
      e.preventDefault();
      showingEdge = !showingEdge;
      var src = showingEdge ? currentEdgeSrc : currentPreviewSrc;
      if (src) els.previewImg.src = src.replace(/\.([a-z]+)\?/, '_600x600.$1?');
    }, { passive: false });
  }

  function updatePreview() {
    if (!pickProduct) return;
    var images = pickProduct.images || [];
    var shapeKey = state.shape.indexOf('Square') > -1 ? 'square' : 'round';
    var colorKey = state.color.toLowerCase();
    var match = null;

    // If a design is selected (pick mode), try to find its specific image
    if (selectedDesignName && state.designType === 'pick') {
      var designSlug = selectedDesignName.toLowerCase().replace(/\s+/g, '-');
      for (var i = 0; i < images.length; i++) {
        var alt = (images[i].alt || '').toLowerCase();
        if (alt.indexOf(designSlug) > -1 && alt.indexOf(shapeKey) > -1 && alt.indexOf(colorKey) > -1) {
          match = images[i].src;
          break;
        }
      }
      // Find the matching edge photo
      currentEdgeSrc = findEdgeImage(selectedDesignName);
    } else {
      currentEdgeSrc = null;
    }

    // Fallback: show blank slate for current shape+color
    if (!match) {
      for (var k = 0; k < images.length; k++) {
        var blankAlt = (images[k].alt || '').toLowerCase();
        if (blankAlt.indexOf('blank') > -1 && blankAlt.indexOf(shapeKey) > -1 && blankAlt.indexOf(colorKey) > -1) {
          match = images[k].src;
          break;
        }
      }
    }

    // Last resort: first image
    if (!match && images.length > 0) {
      match = images[0].src;
    }

    currentPreviewSrc = match;

    if (match) {
      els.previewImg.src = match.replace(/\.([a-z]+)\?/, '_600x600.$1?');
      els.previewImg.classList.remove('landing__hidden');
      els.previewPlaceholder.classList.add('landing__hidden');

      // Show hover hint and pointer cursor if edge image exists
      var hint = document.getElementById('slateEdgeHint');
      if (hint) hint.style.display = currentEdgeSrc ? '' : 'none';
      var box = document.getElementById('slatePreviewBox');
      if (box) {
        if (currentEdgeSrc) box.classList.add('landing__preview-box--has-edge');
        else box.classList.remove('landing__preview-box--has-edge');
      }

      setupPreviewHover();
    } else {
      els.previewImg.classList.add('landing__hidden');
      els.previewPlaceholder.classList.remove('landing__hidden');
      var hint2 = document.getElementById('slateEdgeHint');
      if (hint2) hint2.style.display = 'none';
    }
  }

  // ——— Design Grid ———

  function findDesignImage(designSlug, designName) {
    var productImages = pickProduct ? pickProduct.images : [];
    for (var j = 0; j < productImages.length; j++) {
      var alt = (productImages[j].alt || '').toLowerCase();
      if (alt.indexOf(designSlug) > -1 || alt.indexOf(designName.toLowerCase()) > -1) {
        return productImages[j].src;
      }
    }
    return null;
  }

  function buildDesignGrid() {
    buildDesignGridInto(els.designGrid, 'pick');
    buildDesignGridInto(els.varietyGrid, 'variety');
  }

  function buildDesignGridInto(container, mode) {
    if (!container) return;
    container.innerHTML = '';

    for (var i = 0; i < config.designs.length; i++) {
      var design = config.designs[i];
      var card = document.createElement('div');
      card.className = 'landing__design-card';

      var imgSrc = findDesignImage(design.slug, design.name);

      if (imgSrc) {
        var img = document.createElement('img');
        img.className = 'landing__design-img';
        img.src = imgSrc.replace(/\.([a-z]+)\?/, '_200x200.$1?');
        img.alt = design.name;
        img.loading = 'lazy';
        card.appendChild(img);
      } else {
        card.classList.add('landing__design-card--coming-soon');
        var placeholder = document.createElement('div');
        placeholder.className = 'landing__design-placeholder';
        placeholder.textContent = 'Coming Soon';
        card.appendChild(placeholder);
      }

      var name = document.createElement('div');
      name.className = 'landing__design-name';
      name.textContent = design.name;
      card.appendChild(name);

      if (imgSrc) {
        card.setAttribute('data-design', design.name);
        card.setAttribute('data-img', imgSrc.replace(/\.([a-z]+)\?/, '_200x200.$1?'));
        if (mode === 'variety') {
          card.addEventListener('click', handleVarietyDesignClick);
        } else {
          card.addEventListener('click', handleDesignClick);
        }
      }

      container.appendChild(card);
    }
  }

  function handleDesignClick(e) {
    var card = e.currentTarget;
    var cards = els.designGrid.querySelectorAll('.landing__design-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('landing__design-card--active');
    card.classList.add('landing__design-card--active');
    selectedDesignName = card.getAttribute('data-design');
    updateAddSetState();
    updatePreview();
  }

  // ——— Variety Pack ———

  function initVarietySlots() {
    var count = getSlotCount();
    varietySlots = [];
    for (var i = 0; i < count; i++) varietySlots.push(null);
    renderSlotBar();
  }

  function handleVarietyDesignClick(e) {
    var card = e.currentTarget;
    var designName = card.getAttribute('data-design');
    var imgSrc = card.getAttribute('data-img');

    // Find next empty slot
    var nextEmpty = -1;
    for (var i = 0; i < varietySlots.length; i++) {
      if (!varietySlots[i]) { nextEmpty = i; break; }
    }
    if (nextEmpty === -1) return; // all full

    varietySlots[nextEmpty] = { name: designName, imgSrc: imgSrc };

    // Flash animation on card
    card.classList.remove('landing__design-card--flash');
    void card.offsetWidth; // force reflow
    card.classList.add('landing__design-card--flash');

    renderSlotBar();
    updateAddSetState();
  }

  function clearSlot(index) {
    varietySlots[index] = null;
    renderSlotBar();
    updateAddSetState();
  }

  function renderSlotBar() {
    if (!els.slotBar) return;
    els.slotBar.innerHTML = '';
    var count = getSlotCount();
    var filled = 0;

    // Adjust array length if pack size changed
    while (varietySlots.length < count) varietySlots.push(null);
    if (varietySlots.length > count) varietySlots.length = count;

    for (var i = 0; i < count; i++) {
      var slot = document.createElement('div');
      var data = varietySlots[i];

      if (data) {
        filled++;
        slot.className = 'landing__slot landing__slot--filled';

        var img = document.createElement('img');
        img.className = 'landing__slot-img';
        img.src = data.imgSrc;
        img.alt = data.name;
        slot.appendChild(img);

        var name = document.createElement('div');
        name.className = 'landing__slot-name';
        name.textContent = data.name;
        slot.appendChild(name);

        var removeBtn = document.createElement('button');
        removeBtn.className = 'landing__slot-remove';
        removeBtn.textContent = '\u00d7';
        removeBtn.setAttribute('data-slot', i);
        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          clearSlot(parseInt(this.getAttribute('data-slot'), 10));
        });
        slot.appendChild(removeBtn);
      } else {
        slot.className = 'landing__slot landing__slot--empty';
        slot.textContent = (i + 1);
      }

      els.slotBar.appendChild(slot);
    }

    if (els.slotStatus) {
      els.slotStatus.innerHTML = '<strong>' + filled + '</strong> of <strong>' + count + '</strong> slots filled';
    }
  }

  function handlePackSizeChangeForVariety() {
    if (state.designType === 'variety') {
      var count = getSlotCount();
      while (varietySlots.length < count) varietySlots.push(null);
      if (varietySlots.length > count) varietySlots.length = count;
      renderSlotBar();
      updateAddSetState();
    }
  }

  // ——— Option Button Wiring ———

  function wireOptionButtons(containerId, stateKey, callback) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var buttons = container.querySelectorAll('.landing__option-btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function () {
        var siblings = this.parentElement.querySelectorAll('.landing__option-btn');
        for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('landing__option-btn--active');
        this.classList.add('landing__option-btn--active');
        state[stateKey] = this.getAttribute('data-value');
        updateLineTotal();
        if (callback) callback();
      });
    }
  }

  // ——— Design Type Toggle ———

  function handleDesignTypeChange() {
    // Hide all sections first
    els.pickSection.classList.add('landing__hidden');
    els.customSection.classList.add('landing__hidden');
    if (els.varietySection) els.varietySection.classList.add('landing__hidden');

    // Reset states
    selectedDesignName = null;
    uploadedFileData = null;
    uploadedFileName = null;
    els.uploadStatus.classList.add('landing__hidden');

    if (state.designType === 'pick') {
      els.pickSection.classList.remove('landing__hidden');
      // Clear active design cards
      var cards = els.designGrid.querySelectorAll('.landing__design-card');
      for (var i = 0; i < cards.length; i++) cards[i].classList.remove('landing__design-card--active');
    } else if (state.designType === 'variety') {
      if (els.varietySection) els.varietySection.classList.remove('landing__hidden');
      initVarietySlots();
    } else if (state.designType === 'custom') {
      els.customSection.classList.remove('landing__hidden');
    }

    updateAddSetState();
    updateDesignerLink();
    updatePreview();
  }

  function handleHolderChange() {
    if (state.holder === 'yes') {
      els.holderColorGroup.classList.remove('landing__hidden');
    } else {
      els.holderColorGroup.classList.add('landing__hidden');
    }
  }

  function updateDesignerLink() {
    var params = new URLSearchParams();
    params.set('shape', state.shape);
    params.set('color', state.color);
    params.set('pack', state.packSize);
    els.designerBtn.href = config.customizerUrl + '?' + params.toString();
  }

  // ——— File Upload ———

  function setupFileUpload() {
    els.fileUpload.addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;

      uploadedFileName = file.name;
      var reader = new FileReader();
      reader.onload = function (ev) {
        uploadedFileData = ev.target.result;
        els.uploadStatus.textContent = 'Uploaded: ' + uploadedFileName;
        els.uploadStatus.classList.remove('landing__hidden');
        updateAddSetState();
      };
      reader.readAsDataURL(file);
    });
  }

  // ——— Quantity ———

  function setupQty() {
    $('slateQtyMinus').addEventListener('click', function () {
      if (state.qty > 1) {
        state.qty--;
        els.qty.value = state.qty;
        updateLineTotal();
      }
    });
    $('slateQtyPlus').addEventListener('click', function () {
      state.qty++;
      els.qty.value = state.qty;
      updateLineTotal();
    });
    els.qty.addEventListener('change', function () {
      var v = parseInt(this.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      state.qty = v;
      this.value = v;
      updateLineTotal();
    });
  }

  // ——— Order List / Multi-Add ———

  function addSetToOrder() {
    var designLabel;
    var designSource;
    var uploadData = null;
    var varietyData = null;

    if (state.designType === 'pick') {
      if (!selectedDesignName) return;
      designLabel = selectedDesignName;
      designSource = 'premade';
    } else if (state.designType === 'variety') {
      // Check all slots filled
      var filled = 0;
      var names = [];
      for (var v = 0; v < varietySlots.length; v++) {
        if (varietySlots[v]) { filled++; names.push(varietySlots[v].name); }
      }
      if (filled < getSlotCount()) return;
      designLabel = 'Variety: ' + names.join(', ');
      designSource = 'variety';
      varietyData = varietySlots.slice(); // copy
    } else {
      if (uploadedFileData) {
        designLabel = 'Upload: ' + uploadedFileName;
        designSource = 'upload';
        uploadData = uploadedFileData;
      } else {
        return;
      }
    }

    var product = (state.designType === 'pick' || state.designType === 'variety') ? pickProduct : customProduct;
    var coasterVariant = findCoasterVariant(product, state.packSize, state.shape, state.color);
    var qty = state.qty;

    var coasterPrice = getCoasterTierPrice(qty);
    if (coasterPrice == null) coasterPrice = getVariantPrice(coasterVariant);
    var holderPrice = state.holder === 'yes' ? getTierPrice(config.volumePricing.holder, qty) : 0;
    var giftWrapPrice = state.giftWrap === 'yes' ? getTierPrice(config.volumePricing.giftWrap, qty) : 0;

    // Determine the correct variant ID for volume pricing
    var cartCoasterVariantId = coasterVariant ? coasterVariant.id : null;
    var volCoasterProduct = getVolumeCoasterProduct(qty);
    if (volCoasterProduct) {
      var volVariant = findCoasterVariant(volCoasterProduct, state.packSize, state.shape, state.color);
      if (volVariant) cartCoasterVariantId = volVariant.id;
    }

    // Volume holder variant
    var cartHolderVariantId = null;
    if (state.holder === 'yes') {
      var volHolder = getVolumeHolderProduct(qty);
      if (volHolder) {
        var vh = findHolderVariant.call(null, state.holderColor);
        // Search in volume holder product
        for (var hi = 0; hi < volHolder.variants.length; hi++) {
          if (volHolder.variants[hi].title === state.holderColor || volHolder.variants[hi].option1 === state.holderColor) {
            cartHolderVariantId = volHolder.variants[hi].id;
            break;
          }
        }
      }
    }

    // Volume gift wrap variant
    var cartGiftWrapVariantId = null;
    if (state.giftWrap === 'yes') {
      var volWrap = getVolumeGiftWrapProduct(qty);
      if (volWrap && volWrap.variants[0]) {
        cartGiftWrapVariantId = volWrap.variants[0].id;
      }
    }

    orderSets.push({
      designLabel: designLabel,
      designSource: designSource,
      uploadData: uploadData,
      varietyData: varietyData,
      shape: state.shape,
      color: state.color,
      packSize: state.packSize,
      holder: state.holder === 'yes',
      holderColor: state.holderColor,
      giftWrap: state.giftWrap === 'yes',
      qty: qty,
      coasterVariantId: cartCoasterVariantId,
      coasterPrice: coasterPrice,
      holderPrice: holderPrice,
      giftWrapPrice: giftWrapPrice,
      cartHolderVariantId: cartHolderVariantId,
      cartGiftWrapVariantId: cartGiftWrapVariantId
    });

    // Reset states
    uploadedFileData = null;
    uploadedFileName = null;
    els.uploadStatus.classList.add('landing__hidden');
    els.fileUpload.value = '';
    selectedDesignName = null;

    var cards = els.designGrid.querySelectorAll('.landing__design-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('landing__design-card--active');

    // Reset variety slots
    if (state.designType === 'variety') initVarietySlots();

    state.qty = 1;
    els.qty.value = 1;

    updateAddSetState();
    updateLineTotal();
    renderOrderList();
  }

  function removeSet(index) {
    orderSets.splice(index, 1);
    renderOrderList();
  }

  function renderOrderList() {
    if (orderSets.length === 0) {
      els.orderList.classList.add('landing__hidden');
      return;
    }

    els.orderList.classList.remove('landing__hidden');
    els.orderItems.innerHTML = '';
    var subtotal = 0;

    for (var i = 0; i < orderSets.length; i++) {
      var set = orderSets[i];
      var setTotal = (set.coasterPrice + set.holderPrice + set.giftWrapPrice) * set.qty;
      subtotal += setTotal;

      var addons = [];
      if (set.holder) addons.push('Holder (' + set.holderColor + ')');
      if (set.giftWrap) addons.push('Gift Wrap');

      var item = document.createElement('div');
      item.className = 'landing__order-item';

      var info = document.createElement('div');
      info.className = 'landing__order-item-info';
      info.innerHTML =
        '<strong>' + set.qty + 'x ' + set.packSize + ' / ' + set.shape + ' / ' + set.color + '</strong>' +
        '<span>' + set.designLabel + (addons.length ? ' + ' + addons.join(', ') : '') + '</span>';

      var right = document.createElement('div');
      right.className = 'landing__order-item-right';

      var price = document.createElement('span');
      price.className = 'landing__order-item-price';
      price.textContent = '$' + setTotal.toFixed(2);

      var remove = document.createElement('button');
      remove.className = 'landing__order-item-remove';
      remove.textContent = '\u00d7';
      remove.setAttribute('data-index', i);
      remove.addEventListener('click', function () {
        removeSet(parseInt(this.getAttribute('data-index'), 10));
      });

      right.appendChild(price);
      right.appendChild(remove);
      item.appendChild(info);
      item.appendChild(right);
      els.orderItems.appendChild(item);
    }

    els.subtotal.textContent = '$' + subtotal.toFixed(2);
  }

  // ——— Finish & Add to Cart ———

  function finishOrder() {
    if (orderSets.length === 0) return;

    els.finish.disabled = true;
    els.finish.textContent = 'Adding to Cart...';

    var cartItems = [];

    for (var i = 0; i < orderSets.length; i++) {
      var set = orderSets[i];

      if (set.coasterVariantId) {
        var props = {};

        if (set.designSource === 'variety' && set.varietyData) {
          props['Pack Type'] = 'Variety Pack';
          for (var s = 0; s < set.varietyData.length; s++) {
            if (set.varietyData[s]) {
              props['Coaster ' + (s + 1)] = set.varietyData[s].name;
            }
          }
        } else {
          props['Design'] = set.designLabel;
          if (set.designSource === 'upload' && set.uploadData) {
            props['_Uploaded Design'] = set.uploadData;
          }
        }

        cartItems.push({
          id: set.coasterVariantId,
          quantity: set.qty,
          properties: props
        });
      }

      // Holder — use volume variant ID if available
      if (set.holder) {
        var holderId = set.cartHolderVariantId;
        if (!holderId) {
          var holderVariant = findHolderVariant(set.holderColor);
          if (holderVariant) holderId = holderVariant.id;
        }
        if (holderId) {
          cartItems.push({
            id: holderId,
            quantity: set.qty,
            properties: { 'For Set': set.designLabel + ' (' + set.packSize + ')' }
          });
        }
      }

      // Gift wrap — use volume variant ID if available
      if (set.giftWrap) {
        var wrapId = set.cartGiftWrapVariantId;
        if (!wrapId && giftWrapProduct && giftWrapProduct.variants[0]) {
          wrapId = giftWrapProduct.variants[0].id;
        }
        if (wrapId) {
          cartItems.push({
            id: wrapId,
            quantity: set.qty,
            properties: { 'For Set': set.designLabel + ' (' + set.packSize + ')' }
          });
        }
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        els.finish.disabled = false;
        els.finish.textContent = 'Finish & Go to Cart';
        alert('Something went wrong. Please try again.');
      });
  }

  // ——— Volume Toggle ———

  function setupVolumeToggle() {
    els.volumeToggle.addEventListener('click', function () {
      els.volumeBody.classList.toggle('landing__volume-body--open');
      els.volumeToggle.classList.toggle('landing__volume-toggle--open');
    });
  }

  // ——— Edge Engraving Gallery ———

  function buildEdgeGallery() {
    var gallery = document.getElementById('slateEdgeGallery');
    if (!gallery || !pickProduct) return;

    var images = pickProduct.images || [];
    var edgeImages = [];

    for (var i = 0; i < images.length; i++) {
      var alt = (images[i].alt || '').toLowerCase();
      if (alt.indexOf('edge-engraving') > -1 || alt.indexOf('edge engraving') > -1) {
        // Extract design name from alt text: "hold-my-beer-edge-engraving" → "Hold My Beer"
        var name = alt.replace(/-edge-engraving.*/, '').replace(/-/g, ' ');
        name = name.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        edgeImages.push({ src: images[i].src, name: name });
      }
    }

    if (edgeImages.length === 0) {
      var showcase = document.getElementById('slateEdgeShowcase');
      if (showcase) showcase.style.display = 'none';
      return;
    }

    gallery.innerHTML = '';
    for (var j = 0; j < edgeImages.length; j++) {
      var card = document.createElement('div');
      card.className = 'landing__edge-card';

      var img = document.createElement('img');
      img.src = edgeImages[j].src.replace(/\.([a-z]+)\?/, '_600x600.$1?');
      img.alt = edgeImages[j].name + ' edge engraving detail';
      img.loading = 'lazy';
      card.appendChild(img);

      var label = document.createElement('div');
      label.className = 'landing__edge-card-label';
      label.textContent = edgeImages[j].name;
      card.appendChild(label);

      gallery.appendChild(card);
    }
  }

  // ——— Auto-select design from URL param ———

  function autoSelectDesignFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var designSlug = params.get('design');
    if (!designSlug) return;

    // Find matching design in config
    var matchedName = null;
    for (var i = 0; i < config.designs.length; i++) {
      if (config.designs[i].slug === designSlug) {
        matchedName = config.designs[i].name;
        break;
      }
    }
    if (!matchedName) return;

    // Make sure we're in "Pick a Design" mode
    state.designType = 'pick';
    var designTypeBtns = document.querySelectorAll('#slateDesignType .landing__option-btn');
    for (var j = 0; j < designTypeBtns.length; j++) {
      designTypeBtns[j].classList.remove('landing__option-btn--active');
      if (designTypeBtns[j].getAttribute('data-value') === 'pick') {
        designTypeBtns[j].classList.add('landing__option-btn--active');
      }
    }
    els.pickSection.classList.remove('landing__hidden');
    if (els.customSection) els.customSection.classList.add('landing__hidden');
    if (els.varietySection) els.varietySection.classList.add('landing__hidden');

    // Click the matching design card
    var cards = els.designGrid.querySelectorAll('.landing__design-card');
    for (var k = 0; k < cards.length; k++) {
      var cardDesign = cards[k].getAttribute('data-design');
      if (cardDesign === matchedName) {
        cards[k].click();
        // Scroll to the configurator
        var configurator = document.querySelector('.landing__configurator');
        if (configurator) {
          setTimeout(function () {
            configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
        }
        break;
      }
    }
  }

  // ——— Init ———

  function init() {
    fetchProducts();

    wireOptionButtons('slateShape', 'shape', function () { updatePreview(); updateDesignerLink(); });
    wireOptionButtons('slateColor', 'color', function () { updatePreview(); updateDesignerLink(); });
    wireOptionButtons('slatePackSize', 'packSize', function () { handlePackSizeChangeForVariety(); updateDesignerLink(); });
    wireOptionButtons('slateDesignType', 'designType', handleDesignTypeChange);
    wireOptionButtons('slateHolder', 'holder', handleHolderChange);
    wireOptionButtons('slateHolderColor', 'holderColor');
    wireOptionButtons('slateGiftWrap', 'giftWrap');

    setupQty();
    setupFileUpload();
    setupVolumeToggle();
    updateDesignerLink();

    els.addSet.addEventListener('click', addSetToOrder);
    els.finish.addEventListener('click', finishOrder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
